<template>
  <AddUser update />
</template>

<script>
import AddUser from '../../../components/skillup/user/AddUserList.vue'

import appConfig from '@/app.config'

export default {
  page: {
    title: 'جزئیات کاربر',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-edit-users',
  components: {
    AddUser,
  },
}
</script>
